/**
 * @copyright (C) 2023-2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Jinhyoung Jang (jangjh@rsupport.com)
 *
 * @description
 *
 * @created at 2024-12-10 14:52:38
 **/

import { useState } from "react";

import { Column, Radio, Typography } from "@/frameworks/designStuff/components";
import { _T } from "@rfice/language";

import * as S from "../../emotion";
import { fullWidth } from "../../emotion";

type FullQuality = string;
export default function GraphicContent({
	defaultValue,
	onChange
}: {
	defaultValue: FullQuality;
	onChange: (value: FullQuality) => void;
}) {
	const [fullQuality, setFullQuality] = useState<FullQuality>(defaultValue);
	const handleFullQuality = (userGraphicQuality: FullQuality) => {
		setFullQuality(userGraphicQuality);
		onChange(userGraphicQuality);
	};

	return (
		<S.GraphicContent>
			<Column verticalAlign="center" horizonAlign="distribute" css={fullWidth}>
				<Typography.p typoSize="Title1">{_T("전체 품질 설정")}</Typography.p>
				<S.RadioWrapper gap={2}>
					<Radio
						id="graphic-low"
						name="graphicLevel"
						defaultChecked={fullQuality === "LOW"}
						value="LOW"
						onClick={() => handleFullQuality("LOW")}
					>
						<Typography.p typoSize="Title2">{_T("낮음")}</Typography.p>
					</Radio>
					<Radio
						id="graphic-medium"
						name="graphicLevel"
						defaultChecked={fullQuality === "MEDIUM"}
						value="MEDIUM"
						onClick={() => handleFullQuality("MEDIUM")}
					>
						<Typography.p typoSize="Title2">{_T("보통")}</Typography.p>
					</Radio>
					<Radio
						id="graphic-high"
						name="graphicLevel"
						defaultChecked={fullQuality === "HIGH"}
						value="HIGH"
						onClick={() => handleFullQuality("HIGH")}
					>
						<Typography.p typoSize="Title2">{_T("높음")}</Typography.p>
					</Radio>
				</S.RadioWrapper>
				<S.SubText typoSize="Body5" typoColor="neutral_60_100">
					{_T("PC 사양에 따라 그래픽 품질을 설정하시면, 최적의 환경에서 Rfice를 이용하실 수 있습니다.")}
				</S.SubText>
			</Column>
		</S.GraphicContent>
	);
}
